<section class="container-background container-fluid content">
  <div class="row">
    <h2 class="page-title col-12">Actualites</h2>
  </div>
  <div class="m-2 p-4 bg-white rounded">
    @if (actualites$ | async; as actualites) {
      @if (actualites.length > 0) {
        <div class="row">
          @for (actualite of actualites; track actualite) {
            <div class="col-sm-6 col-lg-4 col-xl-3 mb-4">
              <app-card [link]="actualite.type + '/' + actualite.id" [title]="actualite.date | date:'dd/MM/y'" [text]="actualite.titre"
                [image]="actualite.images[0] ? (actualite.images[0].url | backResource) : ''">
              </app-card>
            </div>
          }
        </div>
      } @else {
        <div class="alert alert-info">Il n'y a aucune actualité à afficher</div>
      }
    }
  </div>
</section>
